(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Home",
            {
                url: "",
                component: "home",
                redirectTo: "Home.Dashboard",
                resolve: {
                    currentUser: ["userApi", function (userApi) {
                        return userApi.GetCurrentUser();
                    }],
                    clientTypes: ["clientApi", function (clientApi) {
                        return clientApi.getClientTypes();
                    }],
                    parentUsers: ["subUserApi", "currentUser", function (subUserApi, currentUser) {
                        return subUserApi.getParents(currentUser.Id);
                    }]
                }
            });
    }]);

    app.component("home",
        {
            templateUrl: "/App/Home/Home-template.html",
            controller: dashboardController,
            bindings: {
                currentUser: "<",
                clientTypes: "<"
            }
        });

    function dashboardController(_, $scope, $state, $mdDialog, $transitions, searchApi, $mdSidenav, $timeout, AuthService, permissionService, userApi, modalService, $cookies) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    activeClient: $state.$current.name.startsWith("Home.Contacts") || $state.$current.name.startsWith("Home.Client"),
                    navIsOpen: false
                },
                modalService: modalService,
                globalSearch: globalSearch,
                viewUser: viewUser,
                selectItem: selectItem,
                openAddClient: openAddClient,
                toggleSearch: toggleSearch,
                toggleSideNav: toggleSideNav,
                goToSearch: goToSearch,
                permissionService: permissionService,
                signOut: signOut,
                bannerIsHidden: true,
                bannerMessage: 'Please note the search functionality in Force is currently down. We are working on getting this back up and running. Thank you for your patience and we apologize for the inconvenience!',
                userHistoryEntries: []
            });

        $transitions.onStart({ to: "**", from: "**" },
            function (trans) {
                var to = trans.to();

                $ctrl.ui.activeClient = to.name.startsWith("Home.Contacts") || to.name.startsWith("Home.Client");
            });

        function viewUser() {
            $state.go("Home.Settings.Agency.User.Personal", { userId: $ctrl.currentUser.Id });
        }

        function toggleSearch() {
            $ctrl.searchToggle = !$ctrl.searchToggle;
            var elem = ng.element("#searchBox");
            if ($ctrl.searchToggle) {
                $timeout(function () {
                    elem[0].focus();
                }, 0);
            }
        }

        function globalSearch(term) {
            return searchApi.search(term).then(function (results) {
                ng.forEach(results,
                    function (row) {
                        if (row.Value.Type === "Advisor" || row.Value.Type === "Client")
                            row.Term = row.Value.FirstName + " " + row.Value.LastName;
                        if (row.Type === "Case") {
                            row.Term = row.Value.Name;
                            row.Value.Type = "Case";
                        }
                    });
                results.sort(function (a, b) {
                    return a.Value.Type - b.Value.Type;
                });
                $ctrl.allCount = results.length;
                $ctrl.clientCount = _.filter(results, _.iteratee(["Value.Type", "Client"])).length;
                $ctrl.advisorCount = _.filter(results, _.iteratee(["Value.Type", "Advisor"])).length;
                return results;
            });
        }

        function signOut($event) {
            var confirm = $mdDialog.confirm({
                theme: "confirmDelete",
                title: "Are you sure you want to sign out of your session?",
                targetEvent: $event,
                ariaLabel: "Confirm session sign out",
                ok: "Sign Out",
                cancel: "Cancel",
                skipHide: true,
                multiple: true,
                onComplete: function () {
                    var $dialog = ng.element(document.querySelector("md-dialog"));
                    var $actionsSection = $dialog.find("md-dialog-actions");
                    var $cancelButton = $actionsSection.children()[0];
                    $cancelButton.focus();
                }
            });

            $mdDialog.show(confirm).then(function () {
                AuthService.logout();
            });
        }

        function selectItem(item) {
            if (!item || !item.Type)
                return;
            switch (item.Type) {
                case "Client":
                    $state.go("Home.Client.Activity", { clientId: item.Id }, {});
                    break;
                case "Advisor":
                    $state.go("Home.Advisor", { advisorId: item.Id });
                    break;
                case "Case":
                    $state.go("Home.Client.Case", { clientId: item.ClientId, caseId: item.Id });
                    break;
                default:
                    return;
            }

        }

        function goToSearch(searchTerm) {
            $state.go("Home.Search", { searchTerm: searchTerm });
        }

        function openAddClient($event) {
            modalService.openAddContact($ctrl.currentUser, $event);

        }

        function toggleSideNav() {
            $ctrl.ui.navIsOpen = !$ctrl.ui.navIsOpen;
        }

        $ctrl.hide = () => {
            $ctrl.bannerIsHidden = true;
            $cookies.put('bannerIsHidden', true);
        };

        $scope.$on('UserHistoryUpdated', (event, data) => {
            $ctrl.userHistoryEntries = data;
        });

        // using ui-sref directive didn't quite work
        $ctrl.navigateTo = entry => {
            $state.go(entry.Route, entry.TransitionParams);
        };

        $ctrl.$onInit = () => {
            //let bannerStatus = $cookies.get('bannerIsHidden');
            //$ctrl.bannerIsHidden = (bannerStatus && bannerStatus === 'true') ? true : false;
            //console.log(bannerStatus === 'true');

            // TODO: need a better way to send back timestamp in local time
            userApi.getCurrentUserHistory().then(response => {
                response.forEach(x => x.TimeStamp += 'Z');
                $ctrl.userHistoryEntries = response;
            });
        };
    }

    app.config(["$urlRouterProvider", function ($urlRouterProvider) {
        $urlRouterProvider.when("", "/Dashboard");
    }]);
})(window.app, window.angular); // jshint ignore:line